import React from 'react';
import { useNavigate } from 'react-router-dom';
import RCAForm from './components/RCAForm';
import { useRCAForm } from './hooks/useRCAForm';
import AppShell from '../../components/layout/AppShell';
import { PageHeader } from '../../components/ui';

const RCAMainPage = () => {
  const navigate = useNavigate();
  const {
    formData,
    loading,
    handleChange,
    handleFaultLogUpload,
    handleImageUpload,
    removeFaultLog,
    removeImage,
    handleImageCaptionChange,
    generatePDF,
  } = useRCAForm();

  const handleSubmit = (e) => {
    e.preventDefault();
    generatePDF();
  };

  return (
    <>
      <PageHeader
        title="Root cause analysis"
        subtitle="Document an incident and generate the RCA report"
        backTo="/"
      />

      <AppShell>
        <div className="mx-auto w-full max-w-4xl rounded-lg border border-border bg-surface p-4 shadow-sm sm:p-6 lg:p-8">
          <RCAForm
            formData={formData}
            handleChange={handleChange}
            handleFaultLogUpload={handleFaultLogUpload}
            handleImageUpload={handleImageUpload}
            handleImageCaptionChange={handleImageCaptionChange}
            removeFaultLog={removeFaultLog}
            removeImage={removeImage}
            loading={loading}
            onCancel={() => navigate('/')}
            onSubmit={handleSubmit}
          />
        </div>
      </AppShell>
    </>
  );
};

export default RCAMainPage;
